import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";
import { panelHeaderMinHeight } from "@shared/SectionPanel/SectionPanel";

export const useStyles = makeStyles()((theme: Theme) => ({
    pageLayout: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        paddingBottom: theme.spacing(4),
    },
    statisticsRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(14),
        paddingBottom: theme.spacing(1),
    },
    statisticsStatus: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: theme.spacing(2),
        maxWidth: 640,
        paddingBottom: theme.spacing(1),
    },
    statisticsLabel: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        color: theme.palette.emteria.text.secondary,
    },
    statusDot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        flexShrink: 0,
    },
    neutralDot: {
        backgroundColor: theme.palette.emteria.text.secondary,
    },
    successDot: {
        backgroundColor: theme.palette.emteria.success,
    },
    errorDot: {
        backgroundColor: theme.palette.emteria.error,
    },
    panelRule: {
        marginLeft: theme.spacing(-3),
        marginRight: theme.spacing(-3),
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    actionHeader: {
        display: "flex",
        alignItems: "stretch",
        gap: theme.spacing(2.5),
        minHeight: panelHeaderMinHeight,
        paddingBottom: theme.spacing(3),
    },
    actionTitleRow: {
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
    },
    actionIcon: {
        width: 48,
        borderRadius: theme.spacing(2),
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.emteria.background.tableHeaders,
        color: theme.palette.emteria.link,
    },
    destructiveIcon: {
        backgroundColor: theme.palette.emteria.alerts.error.bg,
        color: theme.palette.emteria.alerts.error.iconColor,
    },
    actionDescription: {
        color: theme.palette.emteria.text.secondary,
    },
    fieldRow: {
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: theme.spacing(2),
    },
    fieldSlot: {
        paddingBottom: theme.spacing(2.5),
        "& .MuiTextField-root": {
            position: "relative",
        },
        "&& .MuiFormHelperText-root": {
            position: "absolute",
            top: "100%",
            left: 0,
            margin: 0,
            whiteSpace: "nowrap",
        },
    },
    growField: {
        flex: 1,
        minWidth: 0,
    },
    submitRow: {
        display: "flex",
        justifyContent: "flex-end",
    },
    inspectionBox: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        paddingTop: theme.spacing(1),
    },
    inspectionValue: {
        wordBreak: "break-all",
    },
}));
